var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value && _vm.show)?_c('div',{class:{
    'e-circular-loading': true,
    'e-circular-loading--full-page': _vm.fullPage,
  }},[_c('v-progress-circular',_vm._b({attrs:{"indeterminate":_vm.indeterminate,"size":_vm.fullPage ? 50 : _vm.size,"color":_vm.color,"width":_vm.width}},'v-progress-circular',_vm.$attrs,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }